declare global {
	interface Array<T> {
		isEmpty(this: Array<T>): boolean;
		isNotEmpty(this: Array<T>): boolean;
	}
}

var isEmptyPolyFill = () => {
	Array.prototype.isEmpty = function (): boolean {
		return this.length == 0;
	}
}

var isNotEmptyPolyFill = () => {
	Array.prototype.isNotEmpty = function (): boolean {
		return this.length > 0;
	}
}

var setupArrayPolyFills = () => {
	isEmptyPolyFill();
	isNotEmptyPolyFill();
}


export default setupArrayPolyFills;